import Vue from 'vue'
import VueRouter from 'vue-router'
import Packagemaker from '../views/Packagemaker.vue'
import Invoice from '../views/Invoice.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Packagemaker',
    component: Packagemaker
  },
  {
    path: '/Invoice/:application_id',
    name: 'Invoice',
    component: Invoice
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
